<mat-tab-group>
  <mat-tab label="Parametri aplikacije"><app-parameters></app-parameters></mat-tab>
  <mat-tab label="Aplikativni keš"><app-cache></app-cache></mat-tab>
</mat-tab-group>
